import { createContext, useContext, useEffect, useState } from "react";

const EventSessionContext = createContext();

export const EventSessionProvider = ({ children }) => {
  const [eventSessionId, setEventSessionId] = useState(null);

  useEffect(() => {
    const storedSessionId = localStorage.getItem("eventSessionId");

    if (storedSessionId) setEventSessionId(storedSessionId);
  }, []);

  return (
    <EventSessionContext.Provider value={{ eventSessionId, setEventSessionId }}>
      {children}
    </EventSessionContext.Provider>
  );
};

export const useEventSessionContext = () => useContext(EventSessionContext);
